import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { Box, LinearProgress } from '@mui/material';

import GeneralDataForm from './general_data_form';
import { getAllWarehousesAction, getAllWarehousesState } from '../../../../../../../features/inventory/get_all_warehouses';
import { getAllWarehousesNotificationData } from '../../../../../../../core/utils/notification_utils';
import useNotification from '../../../../../../../core/hooks/use_notification';
import ProductsListForm from './products_list_form';
import { WarehouseTypeEnum } from '../../../../../../../core/enums/inventory/warehouse';
import PageHeader from '../../../../../../common/page_header';
import { GET_ROUTE_CUSTOMER } from '../../../../../../../core/constants';

const OrderForm = () => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const { customerId } = useParams();
    const navigate = useNavigate();

    const getAllWarehouses = useSelector(getAllWarehousesState);

    const [view, setView] = useState(0);
    const [form, setForm] = useState({});

    useEffect(() => {
        dispatch(getAllWarehousesAction())
            .then(response => showErrorMessage(getAllWarehousesNotificationData(response)));
    }, [dispatch, showErrorMessage]);

    const onSubmitGeneralData = (values) => {
        setForm(values);
        setView(1);
    };

    const renderView = () => {
        if (getAllWarehouses?.loading) {
            return (
                <Box mt={ 6 } width="100%">
                    <LinearProgress/>
                </Box>
            );
        }

        if (getAllWarehouses?.data) {
            if (view === 1) {
                return (
                    <ProductsListForm
                        customerId={ customerId }
                        form={ form }
                        setView={ setView }
                        warehouseId={ getAllWarehouses?.data?.find(warehouse => warehouse?.type === WarehouseTypeEnum.POD.value && form?.podId === warehouse?.pod?.podId)?.internalId }/>
                );
            } else {
                return (
                    <GeneralDataForm
                        customerId={ customerId }
                        form={ form }
                        onSubmitGeneralData={ onSubmitGeneralData }/>
                );
            }
        }

        return <></>;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title="Dodawanie zakupów w imieniu użytkownika"
                showBack={ true }
                onBack={ () => navigate(GET_ROUTE_CUSTOMER(customerId)) }
            />
            { renderView() }
        </Box>
    );
};

export default OrderForm;